<template>
    <div>
      <span>{{item.updateUser}}</span>
      <span v-if="item.updateUserId"> ({{item.updateUserId}})</span>
      <br />
      <span v-if="item.updateDate">{{updateDateString}}</span>
    </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'UpdatedBy',
  props: {
    item: Object
  },
  computed: {
    updateDateString () {
      return moment(this.item.updateDate).format('DD.MM.YYYY HH:mm:ss')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/UpdatedBy.vue